import { PlantListFilter, SetPlantStateParams } from "../interfaces";
import api from "./apiAgent";

export const fetchPlantList = async (filter: PlantListFilter = null) => {
  return await api.get(`plantlocations?enabled=${filter}`);
};

export const setPlantState = async (
  data: SetPlantStateParams
): Promise<any> => {
  const { location, enabled } = data;
  const state = enabled ? 1 : 0;
  return await api.post(
    `plantlocations/updatePlantStatus?location=${location}&enabled=${state}`
  );
};
